import React from "react";
import withFosRouter from "../FosRouter/withFosRouting";
import withTranslator from "../Translator/withTranslation";
import {compose} from "recompose";

const VillaTileBreadcrumbComponent = (props) => {
    const r = props.r;
    const t = props.t;
    return (
        <div className={props.className}>
            {props.data.country ?
            <div className="inline-block">
                <span className="font-w600">{t(props.data.country)}</span>
                <span className="px-1">-</span>
            </div>
            : ''}
            {props.data.region ?
            <div className="inline-block">
                <a className={props.linkClassName} href={r('show_region', {country: props.data.countrySlug, region: props.data.regionSlug})}>{props.data.region}</a>
                <span className="px-1">-</span>
            </div>
            : ''}
            {props.data.citySlug ?
            <div className="inline-block">
                <a className={props.linkClassName} href={r('show_city', {country: props.data.countrySlug, region: props.data.regionSlug, city: props.data.citySlug})}>{props.data.city}</a>
            </div>
            : ''}
        </div>
    );
}

export const VillaTileBreadcrumb = compose(
    withFosRouter,
    withTranslator)(VillaTileBreadcrumbComponent);
